"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var CardContent = function (_React$Component) {
  _inherits(CardContent, _React$Component);

  function CardContent() {
    _classCallCheck(this, CardContent);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  CardContent.prototype.render = function render() {
    return React.createElement(
      "div",
      { className: "cf-card__content" },
      React.createElement(
        "h3",
        { className: "cf-card__title" },
        this.props.title
      ),
      this.props.children,
      this.props.footerMessage ? React.createElement(
        "div",
        { className: "cf-card__footer_message" },
        this.props.footerMessage
      ) : null
    );
  };

  return CardContent;
}(React.Component);

CardContent.propTypes = {
  title: PropTypes.any.isRequired,
  footerMessage: PropTypes.string
};


module.exports = CardContent;